import React, { Fragment } from "react";
import { ReactComponent as Logo } from "images/Logo.svg";
import Building from "icons/building.svg";
import BuildingActive from "icons/building-active.svg";
import Profile from "icons/profile-circle.svg";
import ProfileActive from "icons/profile-circle-active.svg";
import Money from "icons/money-send.svg";
import MoneyActive from "icons/money-send-green.svg";
import Clipboard from "icons/clipboard-tick.svg";
import ClipboardActive from "icons/clipboard-tick-green.svg";
import NavItem from "./NavItem";

type Props = {
  role: string;
};

const SideBar: React.FC<Props> = ({ role }): JSX.Element => {
  return (
    <aside
      className="flex flex-col h-screen bg-bt-white border border-light-gray"
      style={{ width: "290px" }}
    >
      <div className="flex flex-row justify-center items-center mt-10">
        <Logo height={72} width={115} />
      </div>
      <nav className="flex flex-col mt-28 ml-6 z-20">
        {role === "admin" && (
          <Fragment>
            <NavItem
              route={"entity-management"}
              name={"Entity Management"}
              iconDeactivate={Building}
              iconActive={BuildingActive}
            />
            <NavItem
              route={"bridge-talk-admin"}
              name={"Bridge Talk Admin"}
              iconDeactivate={Profile}
              iconActive={ProfileActive}
            />
            <NavItem
              route={"payments"}
              name={"Payments"}
              iconDeactivate={Money}
              iconActive={MoneyActive}
            />
            <NavItem
              route={"terms-conditions"}
              name={"Terms and Conditions"}
              iconDeactivate={Clipboard}
              iconActive={ClipboardActive}
            />
          </Fragment>
        )}
        {role === "entity" && (
          <Fragment>
            <NavItem
              route={"manage-families"}
              name={"Manage Families"}
              iconDeactivate={Profile}
              iconActive={ProfileActive}
            />
            <NavItem
              route={"add-new-family"}
              name={"Add New Family"}
              iconDeactivate={Building}
              iconActive={BuildingActive}
            />
          </Fragment>
        )}
      </nav>
    </aside>
  );
};

export default SideBar;
